import React, { useState, useEffect } from "react";
import { DatePicker, message, Radio, Space } from "antd";
import { Form, Input, Button, Select, ConfigProvider } from "antd";

import "antd/dist/antd.css";
import moment from "moment";

import "moment/locale/fr";

import { Redirect, Link } from "react-router-dom";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { requestApiAddGuestBySponsor, requestApiGuest } from "../../../store/actions/actions";
import { getTokenDecode } from "../../../utils/security";
import { SecurityToken } from "../../../components/securite";
import Loading from "../../../components/loading";
import { withTranslation } from "react-i18next";
import i18n from "i18next";

import styles from "./newAccountSSO.module.css";

const { Option } = Select;

const today = `${moment()._d.getDate()}/${moment()._d.getMonth() + 1}/${moment()._d.getFullYear()}`;

const AccountSSO = (props) => {
  const [finish, setFinish] = useState(false);
  const [mail_sponsor, setMail_sponsor] = useState("");
  const [loading, setLoading] = useState(true);
  const [locale, setLocale] = useState();
  const [language, setLanguage] = useState();
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    setLanguage(i18n.language[0]);
    if (language === "f") {
      const data = require("antd/lib/locale/fr_FR");
      setLocale(data.default);
    } else {
      setLocale("en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, language]);

  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(SecurityToken(props.history));
    document.title = `${props.t("account_sso.title")} - Wifi Guest`;
    if (sessionStorage.getItem("access_token")) {
      let mail_sponsor = getTokenDecode(sessionStorage.getItem("access_token")).email;
      setMail_sponsor(mail_sponsor);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const callbackAddAccount = (res) => {
    setSubmitLoading(false);
    if (res === 201 || res === 200) {
      message.success(props.t("account_sso.server.success"));
      setFinish(true);
    } else {
      message.error(props.t("account_sso.server.error"));
    }
  };

  const addAccountHandler = (value) => {
    setSubmitLoading(true);
    let date = value.startAt._d;

    props.requestApiAddGuestBySponsor({
      body: {
        guest: value.email,
        firstName: value.name,
        lastName: value.firstName,
        company: value.company,
        sponsor: mail_sponsor,
        startAt: moment(`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`, "DD/MM/YYYY").format("YYYY-MM-DD"),
        validity_period: (value.duration * 86400).toString(),
        language: value.language,
      },
      callback: (e) => {
        callbackAddAccount(e);
      },
    });
  };

  const { t } = props;

  if (finish) {
    return <Redirect to={"/home-sso"} />;
  }
  if (loading)
    return (
      <div>
        <Loading />
      </div>
    );
  return (
    <div className={styles.form_container}>
      <h2>{t("account_sso.title")}</h2>
      <ConfigProvider locale={locale}>
        <Form
          name="basic"
          initialValues={{
            remember: true,
            startAt: moment(today, "DD/MM/YYYY"),
            duration: "1",
            language: "fr",
          }}
          onFinish={addAccountHandler}
          autoComplete="off"
          layout="vertical"
          className={styles.form}
          form={form}
        >
          <div className={styles.form_flex}>
            <Form.Item
              label={t("account_sso.label.firstname")}
              name="firstName"
              className={styles.input_item}
              rules={[
                {
                  required: true,
                  message: t("account_sso.validation.firstname"),
                },
              ]}
            >
              <Input placeholder={t("account_sso.placeholder.firstname")} />
            </Form.Item>
            <Form.Item
              label={t("account_sso.label.lastname")}
              name="name"
              className={styles.input_item}
              rules={[
                {
                  required: true,
                  message: t("account_sso.validation.lastname"),
                },
              ]}
            >
              <Input placeholder={t("account_sso.placeholder.lastname")} />
            </Form.Item>
          </div>
          <Form.Item
            label={t("account_sso.label.mail")}
            name="email"
            validateTrigger="onBlur"
            rules={[
              {
                required: true,
                message: t("account_sso.validation.mail"),
                type: "email",
              },
            ]}
          >
            <Input placeholder={t("account_sso.placeholder.mail")} />
          </Form.Item>

          <Form.Item
            label="Entreprise"
            name="company"
            rules={[
              {
                required: true,
                message: t("account_sso.validation.company"),
              },
            ]}
          >
            <Input placeholder={t("account_sso.placeholder.company")} />
          </Form.Item>
          <div className={styles.form_flex}>
            <Form.Item
              name="startAt"
              label={t("account_sso.label.startAt")}
              rules={[
                {
                  required: true,
                  message: t("account_sso.validation.date"),
                },
              ]}
              className={styles.input_date}
            >
              <DatePicker className={styles.input_date} placeholder={moment().format("DD/MM/YYYY")} format={t("date_format")} />
            </Form.Item>

            <Form.Item name="duration" label={t("account_sso.label.duration")} rules={[{ required: true }]} className={styles.input_duration}>
              <Select>
                <Option value="1">1 {t("account_sso.select.day")}</Option>
                <Option value="2">2 {t("account_sso.select.days")}</Option>
                <Option value="7">7 {t("account_sso.select.days")}</Option>
              </Select>
            </Form.Item>

            <Form.Item
              className={styles.form__group__item}
              style={{ width: "100%" }}
              name="language"
              label={t("admin.users.edit.label.language")}
              rules={[
                {
                  required: true,
                  message: t("admin.users.edit.validation.language"),
                },
              ]}
            >
              <Radio.Group>
                <Space>
                  <Radio value={"fr"}>{t("admin.users.edit.label.french")}</Radio>
                  <Radio value={"en"}>{t("admin.users.edit.label.english")}</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
          <div className={styles.form_footer}>
            <div className={styles.form_footer_mandatory}>
              <p> {t("account_sso.label.mandatory")}</p>
            </div>
            <div className={styles.form_button}>
              <Form.Item>
                <Link to="home-sso">
                  <Button danger size="large">
                    {t("account_sso.button.cancel")}
                  </Button>
                </Link>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" size="large" loading={submitLoading}>
                  {t("account_sso.button.continue")}
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </ConfigProvider>
    </div>
  );
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) => bindActionCreators({ requestApiAddGuestBySponsor, requestApiGuest }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AccountSSO));
